import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import "../../styles/compareStepper.css";

// Segmented "tab" step indicator for the compare wizards (File-to-File,
// DB-to-DB, File-to-DB) — an icon + label per step, matching the Master Suite
// segmented tabs. Purely a visual indicator: navigation is driven by the
// Next/Back buttons inside each pane, so segments are not clickable (prevents
// jumping ahead of required data).
//   <CompareStepper steps={steps} current={activeKey} />
// where each step is { key, label, icon }.
function CompareStepper({ steps = [], current }) {
  return (
    <div className="cmp-stepper">
      {steps.map((s) => {
        const state =
          s.key < current ? "done" : s.key === current ? "active" : "todo";
        return (
          <div
            key={s.key}
            className={`cmp-step cmp-step-${state}`}
            title={s.label}
          >
            {s.icon && (
              <span className="cmp-step-icon">
                {s.icon}
                {state === "done" && (
                  <span className="cmp-step-check">
                    <CheckOutlined />
                  </span>
                )}
              </span>
            )}
            <span className="cmp-step-label">{s.label}</span>
          </div>
        );
      })}
    </div>
  );
}

export default CompareStepper;
